/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    document.addEventListener("DOMContentLoaded", (event) => {
        var links = document.links;
        for (let i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname !== window.location.hostname) {
                links[i].target = "_blank";
                links[i].rel = "noreferrer noopener";
            }
        }


        //Avatar for blog posts
        const avatar = document.querySelector('.article-info__author-avatar');
        if (!avatar) return;
        const newImageUrl = avatar.dataset.author;
        if (!newImageUrl) return;
        const newImage = new Image();
        newImage.onload = function () {
            avatar.src = newImageUrl;
        };
        newImage.onerror = function () {
            // image doesn't exist → нічого не робимо
            console.log('Author image not found');
        };
        newImage.src = newImageUrl;
    });






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('click', function(event) {
  const button = event.target.closest('.boost-card-add-to-cart[data-add-to-cart]');

  if (!button) return;

  const form = button.closest('form');
  const errorContainer = form?.querySelector('[data-cart-errors-container]');

  if (!form || button.disabled) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  button.classList.add('is-loading');
  button.disabled = true;

  if (errorContainer) {
    errorContainer.textContent = '';
    errorContainer.classList.remove('is-expanded');
  }

  fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    },
    body: new FormData(form)
  })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      if (response.status) {
        throw response;
      }

      const cart = document.querySelector('cart-element');

      if (cart && typeof cart.getCart === 'function') {
        cart.button = button;
        cart.getCart();
      } else {
        window.location.href = window.theme?.routes?.cart_url || '/cart';
      }
    })
    .catch(function(error) {
      const message = error?.description || error?.message || 'Unable to add this item to the cart.';

      button.classList.remove('is-loading');
      button.disabled = false;

      if (errorContainer) {
        errorContainer.textContent = message;
        errorContainer.classList.add('is-expanded');
      }
    });
}, true);


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("img").forEach(function (img) {
    const alt = img.getAttribute("alt");

    // If alt is missing or empty
    if (!alt || alt.trim() === "") {
      const src = img.getAttribute("src");
      if (!src) return;

      // Extract filename from URL
      let filename = src.split("/").pop().split("?")[0];

      // Remove file extension
      filename = filename.replace(/\.[^/.]+$/, "");

      // Make it more readable: replace dashes/underscores with spaces
      filename = filename.replace(/[-_]+/g, " ").trim();

      if (filename) {
        img.setAttribute("alt", filename);
      }
    }
  });

      const observer = new MutationObserver(() => {
        const img = document.querySelector('img[src*="bat.bing.com"]');

        if (img) {
            img.setAttribute('alt', 'tracker')
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

function checkCartMinimum() {
  const drawer = document.getElementById('cart-drawer');
  const notice = document.getElementById('cart-minimum-notice');
  const priceElement = document.querySelector('[data-cart-total-price]');

  if (drawer && notice && priceElement) {
    const isDrawerVisible = drawer.classList.contains('is-open');
    const currentTotal = parseFloat(priceElement.textContent.replace(/[^\d.]/g, ''));

    if (isDrawerVisible && currentTotal > 0 && currentTotal < 300) {
      notice.style.display = 'block';
    } else {
      notice.style.display = 'none';
    }
  }
}

function setAnchorTarget() {
  const links = document.querySelectorAll('a');
  links.forEach(link => {
    let href = link.getAttribute('href');
    if (href.includes('anchor')) {
      let id = href.split('#')[1];
      let anchorClass = '.' + id;
      let anchorElement = document.querySelector(anchorClass);
      if (anchorElement) {
        let section = anchorElement.closest('section');
        link.addEventListener('click', function (e) {
          e.preventDefault();
          section.scrollIntoView({ behavior: 'smooth' });
        });
      }
    }
  });
}

const cartNoticeObserver = new MutationObserver(checkCartMinimum);

cartNoticeObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});

document.addEventListener('DOMContentLoaded', checkCartMinimum);
window.addEventListener('load', checkCartMinimum);

document.addEventListener('DOMContentLoaded', setAnchorTarget);